module.exports = __webpack_public_path__ + "static/media/drcall.53c735ed.jpg";